var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4E48C6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6.667 8.667c.579.774 1.466 1.259 2.43 1.328.965.069 1.912-.284 2.596-.968l2-2c1.263-1.308 1.245-3.387-.04-4.673-1.286-1.286-3.365-1.304-4.673-.04l-1.147 1.14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4E48C6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.333 7.333c-.579-.774-1.466-1.259-2.43-1.328-.965-.069-1.912.284-2.596.968l-2 2c-1.263 1.308-1.245 3.387.04 4.673 1.286 1.286 3.365 1.304 4.673.04l1.14-1.14"
  })));
}
export default SvgLink;